import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/index.js';
import { AuthProvider } from './context/AuthContext';
import { AbilityProvider } from './permissions/AbilityContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SalonAccessProvider } from './context/SalonAccessContext';

 const googleClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {googleClientId ? (
        <GoogleOAuthProvider clientId={googleClientId}>
          <AuthProvider>
            <SalonAccessProvider>
              <AbilityProvider>
                <App />
              </AbilityProvider>
            </SalonAccessProvider>
          </AuthProvider>
        </GoogleOAuthProvider>
      ) : (
        <AuthProvider>
          <SalonAccessProvider>
            <AbilityProvider>
              <App />
            </AbilityProvider>
          </SalonAccessProvider>
        </AuthProvider>
      )}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
